import { Destination } from '@/interfaces/destination';
import request from '@/umi-request';
import { AxiosPromise } from 'axios';

export async function queryDestinations(params: any = {}) {
  return request({
    url: 'destinations/',
    method: 'GET',
    params,
  }) as AxiosPromise<Destination[]>;
}
